module.exports = __webpack_public_path__ + "gce.logo.cc1cc.svg";